module.exports = __webpack_public_path__ + "img/16.39644f21.webp";